<template>
  <div class="goodsFilesDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="form.SOPNumber"
        :label="$t.goodsFiles.sopNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button size="small" type="info" @click="gotoSop">{{
            $t.meta.detail
          }}</van-button>
        </template>
      </van-field>
      <van-field v-model="form.WB_Number" :label="$t.goodsFiles.sideWbNumber" readonly />
      <van-field v-model="form.OrderNumber" :label="$t.goodsFiles.erNumber" readonly />
      <van-field
        v-model="form.CustomerNumber"
        :label="$t.goodsFiles.customerNumber"
        readonly
      />
      <van-field
        v-model="form.CompanyName"
        :label="$t.goodsFiles.companyNameSn"
        type="textarea"
        rows="3"
        readonly
      />
      <van-field v-model="wbTypeStr" :label="$t.goodsFiles.businessType" readonly />
      <van-field :label="$t.goodsFiles.commission" readonly>
        <template #button>
          <van-button size="small" type="primary" @click="createEntrustOrderFile">{{
            $t.meta.viewClick
          }}</van-button>
        </template>
      </van-field>
      <van-field :label="$t.goodsFiles.contract" readonly>
        <template #button>
          <van-button size="small" type="primary" @click="getTransportContractContent">{{
            $t.meta.viewClick
          }}</van-button>
        </template>
      </van-field>
      <van-field :label="$t.goodsFiles.quotation" readonly>
        <template #button>
          <van-button size="small" type="primary" @click="createQuotationInfoPdf">{{
            $t.meta.viewClick
          }}</van-button>
        </template>
      </van-field>

      <div class="multi-table" v-if="form.SupplierList">
        <van-field name="stepper" :label="$t.goodsFiles.supplier" required>
          <template #input>
            <van-stepper
              :min="0"
              :value="form.SupplierCount"
              @plus="handleAdd(form.SupplierCount + 1)"
              :disable-input="true"
              :disable-minus="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.SupplierList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(item.EOSId)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.Email"
            :label="$t.goodsFiles.emailAddress"
            :placeholder="$t.meta.input"
            type="textarea"
            required
          >
            <template #button>
              <van-button
                size="small"
                type="info"
                @click="updateSupplierEmailInfo(item.EOSId, item.Email)"
                >{{ $t.meta.save }}</van-button
              >
            </template>
          </van-field>
          <van-field
            v-model="item.WarehouseNumber"
            :label="$t.goodsFiles.warehouseNumber"
            readonly
          />
          <van-field
            v-model="item.PhoneNumber"
            :label="$t.goodsFiles.supplierPhone"
            readonly
          />
          <van-field :label="$t.goodsFiles.invoice" readonly>
            <template #button>
              <van-button
                size="small"
                type="primary"
                @click="createPriceListPdf(item)"
                v-if="item.WCUserId"
                >{{ $t.meta.viewClick }}</van-button
              >
              <div v-else>{{ $t.goodsFiles.unupload }}</div>
            </template>
          </van-field>
          <van-field :label="$t.goodsFiles.packingList" readonly>
            <template #button>
              <van-button
                size="small"
                type="primary"
                @click="createPackingListPdf(item)"
                v-if="item.WCUserId"
                >{{ $t.meta.viewClick }}</van-button
              >
              <div v-else>{{ $t.goodsFiles.unupload }}</div>
            </template>
          </van-field>
          <van-field :label="$t.goodsFiles.noticeBill" readonly>
            <template #button>
              <van-button
                size="small"
                type="primary"
                @click="warehouseShow(item.WarehousingApplyForList)"
                v-if="item.WarehousingApplyForList.length > 0"
                >{{ $t.meta.viewClick }}</van-button
              >
              <div v-else>{{ $t.goodsFiles.unupload }}</div>
            </template>
          </van-field>
          <van-field :label="$t.goodsFiles.fileList" readonly>
            <template #button>
              <van-button size="small" type="primary" @click="dialogFilesShow(item)">{{
                $t.meta.viewClick
              }}</van-button>
            </template>
          </van-field>
          <van-field :label="$t.goodsFiles.emailShare" readonly>
            <template #button>
              <van-button size="small" type="info" @click="emailShow(item.EOSId)">{{
                $t.goodsFiles.clickShare
              }}</van-button>
            </template>
          </van-field>
        </div>
      </div>

      <div class="title">{{ $t.goodsFiles.goodsFiles }}</div>

      <div class="multi-table" v-if="form.WaybillRecord" style="margin-top: 0px">
        <van-field name="stepper" label="PL">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.WaybillRecord.PL_FileList.length"
              @minus="handlePLDel"
              @plus="handlePLAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.WaybillRecord.PL_FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handlePLByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead1" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.WaybillRecord">
        <van-field name="stepper" label="INV">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.WaybillRecord.INV_FileList.length"
              @minus="handleINVDel"
              @plus="handleINVAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.WaybillRecord.INV_FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleINVByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead2" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.WaybillRecord">
        <van-field name="stepper" label="CO">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.WaybillRecord.CO_FileList.length"
              @minus="handleCODel"
              @plus="handleCOAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.WaybillRecord.CO_FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCOByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead3" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.WaybillRecord">
        <van-field name="stepper" label="CCPIT">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.WaybillRecord.CCPIT_FileList.length"
              @minus="handleCCPITDel"
              @plus="handleCCPITAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.WaybillRecord.CCPIT_FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleCCPITByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead4" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="multi-table" v-if="form.WaybillRecord">
        <van-field name="stepper" label="OTHER">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.WaybillRecord.OTHER_FileList.length"
              @minus="handleOTHERDel"
              @plus="handleOTHERAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.WaybillRecord.OTHER_FileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleOTHERByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FileAddress))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.FileAddress"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead5" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FileAddress"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit">{{
          $t.goodsFiles.saveButton
        }}</van-button>
      </div>

      <van-dialog
        :title="$t.goodsFiles.noticeBill"
        width="90%"
        v-model="warehouseVisible"
        :cancel-button-text="$t.meta.close"
        :show-cancel-button="true"
        :show-confirm-button="false"
      >
        <slot name="default">
          <div class="goodsFilesDetail-alert">
            <van-form label-width="120px">
              <div class="multi-table" v-if="warehouse">
                <van-field name="stepper" :label="$t.goodsFiles.noticeBill" required>
                  <template #input>
                    <van-stepper :min="0" :value="warehouse.length" :disabled="true" />
                  </template>
                </van-field>
                <div v-for="(item, index) in warehouse" :key="index">
                  <van-field :label="'No.' + (index + 1)">
                    <template #button>
                      <van-button
                        size="small"
                        type="info"
                        @click="createWarehousingNoticeFile(item.WHAFId)"
                        >{{ $t.goodsFiles.viewFile }}</van-button
                      >
                    </template>
                  </van-field>
                </div>
              </div>
            </van-form>
          </div>
        </slot>
      </van-dialog>

      <van-dialog
        :title="$t.goodsFiles.supplierFileList"
        width="90%"
        v-model="filesVisible"
        @confirm="addEntrustOrderSupplierFile"
        @cancel="filesVisible = false"
        :cancel-button-text="$t.meta.close"
        :confirm-button-text="$t.meta.confirm"
        :show-cancel-button="true"
        :show-confirm-button="true"
      >
        <slot name="default">
          <div class="goodsFilesDetail-alert">
            <van-form label-width="120px">
              <div class="multi-table" v-if="files.list">
                <van-field
                  name="stepper"
                  :label="$t.goodsFiles.supplierFileList"
                  required
                >
                  <template #input>
                    <van-stepper
                      :min="0"
                      :value="files.list.length"
                      @plus="handleFilesAdd"
                      :disable-input="true"
                      :disable-minus="true"
                    />
                  </template>
                </van-field>
                <div v-for="(item, index) in files.list" :key="index">
                  <van-field :label="'No.' + (index + 1)">
                    <template #input>
                      <van-button
                        @click="imagePreview(imgUrlFilter(item.FileAddress))"
                        type="primary"
                        size="small"
                        style="vertical-align: top; margin: 10px 30px 10px 0px"
                        v-if="item.FileAddress"
                        >{{ $t.meta.view }}</van-button
                      >
                      <van-uploader
                        :after-read="afterRead6"
                        @click-upload="uploaderClick(index)"
                      >
                        <van-image
                          :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                          width="50"
                          height="50"
                          fit="contain"
                          style="vertical-align: top"
                          v-if="item.FileAddress"
                        ></van-image>
                        <van-button
                          type="info"
                          size="small"
                          style="vertical-align: top; margin: 10px 30px 10px 0px"
                          v-else
                          >{{ $t.meta.upload }}</van-button
                        >
                      </van-uploader>
                    </template>
                  </van-field>
                </div>
              </div>
            </van-form>
          </div>
        </slot>
      </van-dialog>

      <van-dialog
        :title="$t.goodsFiles.sendInvite"
        width="90%"
        v-model="emailVisible"
        @cancel="emailVisible = false"
        @confirm="entrustOrderInvitationEmail"
        :cancel-button-text="$t.meta.close"
        :confirm-button-text="$t.meta.confirm"
        :show-cancel-button="true"
        :show-confirm-button="true"
      >
        <slot name="default">
          <div class="goodsFilesDetail-alert">
            <van-form label-width="120px" style="margin-top: 15px">
              <van-field
                v-model="inviter.email"
                :label="$t.goodsFiles.emailAddress"
                :placeholder="$t.goodsFiles.placeholderEmail"
                type="textarea"
                required
              />
            </van-form>
          </div>
        </slot>
      </van-dialog>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Stepper, Uploader } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Stepper).use(Uploader);

export default {
  name: "goodsFilesDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      wbTypeStr: "",
      SOPId: "",
      warehouseVisible: false,
      //入库通知书
      warehouse: [],
      //其他文件
      filesVisible: false,
      files: {
        eosid: "",
        list: [],
        length: 0,
      },
      filesIndex: 0,
      //邮箱分享
      emailVisible: false,
      inviter: {
        eosid: "",
        email: "",
      },
    };
  },
  created() {
    const { SOPId } = this.$route.query;
    if (SOPId) {
      this.SOPId = SOPId;
      this.getCargoTransportFileDetail();
    }
  },
  methods: {
    gotoSop() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "commissionCreate",
        name: "commissionCreate",
        query: [
          {
            name: "OrderId",
            value: this.form.OrderId,
          },
          {
            name: "SOPId",
            value: this.form.SOPId,
          },
          {
            name: "isView",
            value: true,
          },
        ],
      });
    },
    handleOTHERByIndex(index) {
      if (this.form.WaybillRecord.OTHER_FileList.length > 0) {
        this.form.WaybillRecord.OTHER_FileList.splice(index, 1);
      }
    },
    handleOTHERDel() {
      if (this.form.WaybillRecord.OTHER_FileList.length > 0) {
        this.form.WaybillRecord.OTHER_FileList.pop();
      }
    },
    handleOTHERAdd() {
      this.form.WaybillRecord.OTHER_FileList.push({
        FileType: 5,
        FileAddress: "",
      });
    },

    handleCCPITByIndex(index) {
      if (this.form.WaybillRecord.CCPIT_FileList.length > 0) {
        this.form.WaybillRecord.CCPIT_FileList.splice(index, 1);
      }
    },
    handleCCPITDel() {
      if (this.form.WaybillRecord.CCPIT_FileList.length > 0) {
        this.form.WaybillRecord.CCPIT_FileList.pop();
      }
    },
    handleCCPITAdd() {
      this.form.WaybillRecord.CCPIT_FileList.push({
        FileType: 4,
        FileAddress: "",
      });
    },

    handleCOByIndex(index) {
      if (this.form.WaybillRecord.CO_FileList.length > 0) {
        this.form.WaybillRecord.CO_FileList.splice(index, 1);
      }
    },
    handleCODel() {
      if (this.form.WaybillRecord.CO_FileList.length > 0) {
        this.form.WaybillRecord.CO_FileList.pop();
      }
    },
    handleCOAdd() {
      this.form.WaybillRecord.CO_FileList.push({
        FileType: 3,
        FileAddress: "",
      });
    },

    handleINVByIndex(index) {
      if (this.form.WaybillRecord.INV_FileList.length > 0) {
        this.form.WaybillRecord.INV_FileList.splice(index, 1);
      }
    },
    handleINVDel() {
      if (this.form.WaybillRecord.INV_FileList.length > 0) {
        this.form.WaybillRecord.INV_FileList.pop();
      }
    },
    handleINVAdd() {
      this.form.WaybillRecord.INV_FileList.push({
        FileType: 2,
        FileAddress: "",
      });
    },

    handlePLByIndex(index) {
      if (this.form.WaybillRecord.PL_FileList.length > 0) {
        this.form.WaybillRecord.PL_FileList.splice(index, 1);
      }
    },
    handlePLDel() {
      if (this.form.WaybillRecord.PL_FileList.length > 0) {
        this.form.WaybillRecord.PL_FileList.pop();
      }
    },
    handlePLAdd() {
      this.form.WaybillRecord.PL_FileList.push({
        FileType: 1,
        FileAddress: "",
      });
    },

    emailShow(id) {
      this.inviter.eosid = id;
      this.emailVisible = true;
    },
    entrustOrderInvitationEmail() {
      this.$commonMethod.showLoading();
      let param = {
        EOSId: this.inviter.eosid,
        Email: this.inviter.email,
      };
      this.$api.logisticsManagement
        .entrustOrderInvitationEmail(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.emailVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    addEntrustOrderSupplierFile() {
      let param = [];
      for (const item of this.files.list) {
        if (!item.EOSFId) {
          param.push(item);
        }
      }
      this.$commonMethod.showLoading();
      this.$api.logisticsManagement
        .addEntrustOrderSupplierFile(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleFilesAdd() {
      this.files.list.push({
        EOSId: this.files.eosid,
        FileAddress: "",
      });
    },
    dialogFilesShow(item) {
      this.files.eosid = item.EOSId;
      this.getEntrustOrderSupplierFileList().then((success) => {
        if (success) this.filesVisible = true;
      });
    },
    getEntrustOrderSupplierFileList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          EOSId: this.files.eosid,
        };
        this.$api.logisticsManagement
          .getEntrustOrderSupplierFileList(param)
          .then((res) => {
            this.files.list = res.data || [];
            this.files.length = res.data.length + 1 || 0;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    warehouseShow(item) {
      this.warehouseVisible = true;
      this.warehouse = item;
    },
    //供应商打印
    createWarehousingNoticeFile(id) {
      var param = {
        WHAFId: id,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createWarehousingNoticeFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    createPackingListPdf(item) {
      var param = {
        EOSId: item.EOSId,
        WCUserId: item.WCUserId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createPackingListPdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    createPriceListPdf(item) {
      var param = {
        EOSId: item.EOSId,
        WCUserId: item.WCUserId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createPriceListPdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    //委托单打印
    createQuotationInfoPdf() {
      var param = {
        QRId: this.form.QRId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createQuotationInfoPdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    getTransportContractContent() {
      var param = {
        CustomerId: this.form.CustomerId,
        BusinessType: this.form.BusinessType,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "getTransportContractContent",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    createEntrustOrderFile() {
      var param = {
        OrderId: this.form.OrderId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createEntrustOrderFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
    updateSupplierEmailInfo(id, email) {
      this.$commonMethod.showLoading();
      var param = {
        EOSId: id,
        Email: email,
      };
      this.$api.logisticsManagement
        .updateSupplierEmailInfo(param)
        .then(() => {
          this.getCargoTransportFileDetail();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleDelByIndex(id) {
      this.$commonMethod.showLoading();
      var param = {
        EOSId: id,
      };
      this.$api.logisticsManagement
        .deleteEntrustOrderSupplier(param)
        .then(() => {
          this.getCargoTransportFileDetail();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    handleAdd(qty) {
      this.$commonMethod.showLoading();
      var param = {
        OrderId: this.form.OrderId,
        OrderNumber: this.form.OrderNumber,
        Quantity: qty,
      };
      this.$api.logisticsManagement
        .addEntrustOrderSupplier(param)
        .then(() => {
          this.getCargoTransportFileDetail();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        WB_Number: this.form.WB_Number,
        PARId: this.form.WaybillRecord.PARId,
        PL_FileList: this.form.WaybillRecord.PL_FileList,
        INV_FileList: this.form.WaybillRecord.INV_FileList,
        CO_FileList: this.form.WaybillRecord.CO_FileList,
        CCPIT_FileList: this.form.WaybillRecord.CCPIT_FileList,
        OTHER_FileList: this.form.WaybillRecord.OTHER_FileList,
      };
      this.$api.logisticsManagement
        .saveCargoFile(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCargoTransportFileDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          SOPId: this.SOPId,
        };
        this.$api.logisticsManagement
          .getCargoTransportFileDetail(param)
          .then((res) => {
            this.form = res.data;
            if (this.form.BusinessType == 1) {
              this.wbTypeStr = this.$t.meta.wbType1;
            }
            if (this.form.BusinessType == 2) {
              this.wbTypeStr = this.$t.meta.wbType2;
            }
            if (this.form.BusinessType == 3) {
              this.wbTypeStr = this.$t.meta.wbType3;
            }
            if (this.form.BusinessType == 4) {
              this.wbTypeStr = this.$t.meta.wbType4;
            }
            if (this.form.BusinessType == 5) {
              this.wbTypeStr = this.$t.meta.wbType5;
            }
            this.$commonMethod.fieldRefresh(".goodsFilesDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WaybillRecord.PL_FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WaybillRecord.INV_FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead3(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WaybillRecord.CO_FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead4(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WaybillRecord.CCPIT_FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead5(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WaybillRecord.OTHER_FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead6(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.files.list[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.goodsFilesDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;

    .subTotal-label {
      margin-bottom: 15px;
    }

    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;

      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }

      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;

      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }

  .goodsFilesDetail-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
</style>
